// src/utils/suggestedMemberProfiles.js
//
// Perfis prontos para o cenário de escola: quando um titular está montando o
// círculo pela primeira vez (ou a qualquer momento depois), escolher um destes
// já grava um molde de permissões coerente com o papel, em vez de a pessoa sair
// do zero configurando a grade manualmente.
//
// Só entram em jogo quando o titular ESCOLHE a sugestão — digitar um perfil
// livre continua sem criar nada até a pessoa salvar um molde explicitamente.

function resource({ view = true, create = false, edit = false, delete: del = false } = {}) {
  return { view, create, edit, delete: del };
}

export const SUGGESTED_MEMBER_PROFILES = [
  {
    relationshipType: "Professor",
    description: "Cria, edita e exclui textos, atividades e notas para a turma.",
    permissions: {
      texts: resource({ create: true, edit: true, delete: true }),
      notes: resource({ create: true, edit: true, delete: true }),
      activities: resource({ create: true, edit: true, delete: true }),
      restrictToTitular: false,
      canManageCircle: false,
    },
  },
  {
    relationshipType: "Aluno",
    description: "Responde atividades e faz anotações.",
    permissions: {
      texts: resource(),
      notes: resource({ create: true, edit: true, delete: true }),
      activities: resource(),
      restrictToTitular: true,
      canManageCircle: false,
    },
  },
  {
    relationshipType: "Administrador",
    description: "Cadastra alunos e libera turmas para professores.",
    permissions: {
      texts: resource(),
      notes: resource(),
      activities: resource(),
      // Desligada: quem é administrador não cria conteúdo (a grade acima já
      // é só visualização), então a restrição não mudaria nada além de travar
      // células que já estão desligadas.
      restrictToTitular: false,
      canManageCircle: true,
    },
  },
  {
    relationshipType: "Coordenador",
    description: "Gerencia conteúdo e turmas: o que o Professor e o Administrador fazem.",
    permissions: {
      texts: resource({ create: true, edit: true, delete: true }),
      notes: resource({ create: true, edit: true, delete: true }),
      activities: resource({ create: true, edit: true, delete: true }),
      restrictToTitular: false,
      canManageCircle: true,
    },
  },
];
